<template>
  <div style="padding: 0 20px;">
    <el-row>
      <el-col :span="24">
        <el-button
            style="padding: 0; margin: 20px"
            type="text"
            icon="el-icon-back"
            @click="backPrePage()"
        >
          返回
        </el-button>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-form ref="form" :model="form" label-width="150px" :disabled="formLoading">
        <el-form-item label="类型">
          <el-select v-model="form.scope" placeholder="请选择" size="small">
          <el-option label="通用" :value="1">通用</el-option>
          <el-option label="心理咨询" :value="3">心理咨询</el-option>
          <el-option label="课程" :value="2">课程</el-option>
        </el-select>
        </el-form-item>
        <el-form-item label="关键词" required>
          <el-input size="medium" v-model="form.word" style="width:400px"></el-input>
        </el-form-item>

        <el-form-item>
          <template v-if="type == 'create'">
            <el-button type="primary" @click="onSubmit" :loading="onSubmitLoading">立即创建</el-button>
          </template>
          <template v-else>
            <el-button type="primary" @click="onUpdate" :loading="onSubmitLoading">保存</el-button>
          </template>

          <el-button @click="backPrePage()">取消</el-button>
        </el-form-item>
      </el-form>
    </el-row>
  </div>
</template>

<script>
import {getWordInfo, createWord, updateWord} from "@/api/sensitive";

export default {
  data: function () {
    return {
      id: '',
      type: 'create',
      form: {
        scope:1
      },
      onSubmitLoading: false,
      formLoading: false,
    };
  },
  created: function () {
    this.type = this.$route.query.type
    if (this.type == 'update') {
      this.id = this.$route.query.id;
      this.getInfo()
    }
  },
  methods: {
    getInfo() {
      this.formLoading = true;
      getWordInfo({
        id: this.id
      }).then(response => {
        this.formLoading = false;
        this.form = response.data;
      });
    },
    uploadSuccess(value) {
      this.form[value.formName] = value.fileUrl
    },
    onUpdate() {
      this.onSubmitLoading = true;
      updateWord(this.form).then((res) => {
        this.onSubmitLoading = false;
        if (res.code == 1) {
          this.$message({
            showClose: true,
            duration: 6000,
            message: '修改成功',
            type: 'success'
          });
          this.backPrePage();
        }
      });
    },
    onSubmit() {
      this.onSubmitLoading = true;
      createWord(this.form).then((res) => {
        this.onSubmitLoading = false;
        if (res.code == 1) {
          this.form = {}
          this.$message({
            showClose: true,
            duration: 6000,
            message: '创建成功',
            type: 'success'
          });
          this.backPrePage();
        }
      });
    },
    backPrePage() {
      this.$router.back();
    },
  }
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  min-height: 70px;
  line-height: 70px;
  text-align: center;
}

.avatar {
  width: 100px;
  min-height: 70px;
  display: block;
}
.product-img{
  width: 80px;
  height: 80px;
  margin: 0 10px 0 0;
}
</style>

